import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ActivitiesComponent } from './components/pages/coach/activities/activities.component';
import { CoachCheckinComponent } from './components/pages/coach/coach-check-in/coach-check-in.component';
import { DataPrivacyComponent } from './components/pages/common/data-privacy/data-privacy.component';
import { ForbiddenComponent } from './components/pages/common/forbidden/forbidden.component';
import { LoginComponent } from './components/pages/common/login/login.component';
import { ProfileComponent } from './components/pages/common/profile/profile.component';
import { RegisterComponent } from './components/pages/common/register/register.component';
import { ResetComponent } from './components/pages/common/reset/reset.component';
import { SetPasswordComponent } from './components/pages/common/set-password/set-password.component';
import { VerifyComponent } from './components/pages/common/verify/verify.component';
import { CheckInComponent } from './components/pages/user/check-in/check-in.component';
import { HomeComponent } from './components/pages/user/home/home.component';
import { WeightComponent } from './components/pages/user/weight/weight.component';
import { RouteSegmentEnum } from './enums/routes.enum';
import { UserRoleEnum } from './enums/user.enums';
import { permissionsGuard } from './guards/permission.guard';

const routes: Routes = [
  {
    path: RouteSegmentEnum.USER,
    canActivate: [permissionsGuard([UserRoleEnum.USER])],
    children: [
      {
        path: RouteSegmentEnum.HOME,
        component: HomeComponent,
      },
      {
        path: RouteSegmentEnum.CHECK_IN,
        component: CheckInComponent,
      },
      {
        path: RouteSegmentEnum.WEIGHT,
        component: WeightComponent,
      },
      {
        path: RouteSegmentEnum.PROFILE,
        component: ProfileComponent,
      },
    ],
  },
  {
    path: RouteSegmentEnum.COACH,
    canActivateChild: [permissionsGuard([UserRoleEnum.COACH])],
    children: [
      {
        path: RouteSegmentEnum.CHECK_IN,
        component: CoachCheckinComponent,
      },
      {
        path: RouteSegmentEnum.PROFILE,
        component: ProfileComponent,
      },
      {
        path: RouteSegmentEnum.ACTIVITY,
        component: ActivitiesComponent,
      },
    ],
  },

  {
    path: RouteSegmentEnum.PRIVACY_POLICY,
    component: DataPrivacyComponent,
  },
  {
    path: RouteSegmentEnum.LOGIN,
    component: LoginComponent,
  },
  {
    path: RouteSegmentEnum.REGISTER,
    component: RegisterComponent,
  },
  {
    path: RouteSegmentEnum.RESET,
    component: ResetComponent,
  },
  {
    path: RouteSegmentEnum.VERIFICATION,
    component: VerifyComponent,
  },
  {
    path: RouteSegmentEnum.SET_PASSWORD,
    component: SetPasswordComponent,
  },
  {
    path: RouteSegmentEnum.FORBIDDEN,
    component: ForbiddenComponent,
  },
  {
    path: '**',
    component: LoginComponent,
  },
];

const routerOptions: ExtraOptions = {
  // enableTracing: true,
  scrollPositionRestoration: 'top',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
